import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBase } from '../input-base';

@Component({
  selector: 'hcc-radio-button',
  templateUrl: './radio-button.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioButtonComponent),
      multi: true
    }
  ]
})
export class RadioButtonComponent extends InputBase<string> {
  constructor() {
    super();
  }

  OnRadioChange(val) {
    super.writeValue(val);
    this.frmGroup.get(this.fieldInfo.fieldName).setValue(val);
    //super.writeValue(val);
  }
}
